export enum AlgorithmUrl {
  base = '/algorithms{/id}{?dataObjectVersionId,isAlgorithmView,search,statusCodes,validFrom,validTo,indicatorIds,dimensionIds,dimensionCategoryIds}',
  BY_IDS = '/algorithms/by-ids{?algorithmIds}',
  overview = '/algorithms/overview{?dataObjectVersionId}',
  CLONE = '/algorithms/clone',
  SOURCES = '/algorithms/{id}/sources',
  MAPPINGS = '/algorithms/{id}/mappings',
  JOINS = '/algorithms/{id}/joins',
  MAPPINGS_AND_JOINS = '/algorithms/{id}/mappings-and-joins',
  FILTER_CLAUSE = '/algorithms/{id}/filter-clause',
  TARGET = '/algorithm-target/{targetId}',
  TARGETS = '/algorithm-target/algorithm-targets/{id}',
  BROKEN_REFERENCES = '/algorithms/broken-references{?algorithmIds*}',
}
